import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMinus } = FiIcons;

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'Will this sound robotic? I need it to represent my brand.',
      answer: 'Not at all. We train the AI on your specific language, tone, and methodology from your website, articles, and videos. It will sound like a natural extension of you.'
    },
    {
      question: 'Can it integrate with my calendar and CRM?',
      answer: 'Yes. It integrates directly with Calendly, Acuity, HubSpot, and more. Qualified leads can book directly into your calendar, and their data is automatically sent to your CRM.'
    },
    {
      question: 'What if a lead is a perfect fit but has a unique question?',
      answer: 'The AI is trained to recognize when a human touch is needed. It can seamlessly escalate the conversation to you via email, providing the full transcript so you can jump in with full context.'
    },
    {
      question: 'How are the qualifying questions determined?',
      answer: 'During our 30-minute kickoff call, we work with you to define your exact criteria. We\'ll map out the questions, logic, and budget requirements to ensure the AI only books your ideal clients.'
    },
    {
      question: 'Can I update the questions later?',
      answer: 'Yes! You have full access to the chatbot\'s knowledge base. You can easily tweak questions, add new services, or adjust your criteria as your business evolves.'
    },
    {
      question: 'Why is the offer only $250? What\'s the catch?',
      answer: 'It\'s a Black Friday special from our platform partner, Noem. They know that once you see how much time and money this saves you, you\'ll become a customer for life. There are no hidden fees.'
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
            Your Questions, <span className="text-blue-600">Answered</span>
          </h2>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full p-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
                >
                  <span className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                  <SafeIcon 
                    icon={activeIndex === index ? FiMinus : FiPlus} 
                    className="text-2xl text-blue-600 flex-shrink-0"
                  />
                </button>
                
                <AnimatePresence>
                  {activeIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="border-t border-gray-200"
                    >
                      <div className="p-6 pt-4">
                        <p className="text-gray-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;